// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var selectedClasses = [
  "border-l-2",
  "border-l-[#FF4D00]",
  "bg-[#FF4D00]/[0.04]"
];

function toggleSelectedClasses(element) {
  Belt_Array.forEach(selectedClasses, (function (name) {
          DomEl$GameDataCore.toggleClass(element, name);
        }));
}

function mounted() {
  var self = this ;
  var element = self.el;
  self.pendingClick = undefined;
  self.lastClickTime = 0;
  var handleClick = function ($$event) {
    var target = $$event.target;
    if (target == null) {
      return ;
    }
    var match = target.closest("input[type=\"checkbox\"], label");
    if (!(match == null)) {
      return ;
    }
    var now = Date.now();
    var elapsed = now - self.lastClickTime | 0;
    var timer = self.pendingClick;
    if (timer !== undefined && elapsed < 300) {
      clearTimeout(Caml_option.valFromOption(timer));
      self.pendingClick = undefined;
      self.lastClickTime = 0;
      toggleSelectedClasses(element);
      var reviewId = DomEl$GameDataCore.data(element, "review-id");
      if (reviewId !== "") {
        self.pushEvent("select-table-row", {
              value: reviewId
            });
        return ;
      } else {
        return ;
      }
    }
    self.lastClickTime = now;
    var timer$1 = setTimeout((function () {
            self.pendingClick = undefined;
            var reviewId = DomEl$GameDataCore.data(element, "review-id");
            if (reviewId !== "") {
              self.pushEvent("select-review", {
                    id: reviewId
                  });
              return ;
            }
            
          }), 300);
    self.pendingClick = Caml_option.some(timer$1);
  };
  self.onClick = handleClick;
  element.addEventListener("click", handleClick);
}

function destroyed() {
  var self = this ;
  var timer = self.pendingClick;
  if (timer !== undefined) {
    clearTimeout(Caml_option.valFromOption(timer));
  }
  self.el.removeEventListener("click", self.onClick);
}

var reviewRow = {
  mounted: mounted,
  destroyed: destroyed
};

var dblclickWindowMs = 300;

export {
  dblclickWindowMs ,
  selectedClasses ,
  toggleSelectedClasses ,
  mounted ,
  destroyed ,
  reviewRow ,
}
/* mounted Not a pure module */
